import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.pageYOffset > 100;
      setScrolled(isScrolled);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <nav 
      className="navbar" 
      style={{
        background: scrolled ? 'rgba(26, 31, 58, 0.98)' : 'rgba(26, 31, 58, 0.95)',
        boxShadow: scrolled ? '0 5px 30px rgba(0, 0, 0, 0.3)' : 'none'
      }}
    >
      <div className="nav-container">
        <Link to="/" className="logo">
          <span className="logo-icon">🍬</span>
          <span className="logo-text">Sweet & Snack World</span>
        </Link>
        <ul className="nav-menu">
          <li><Link to="/" className={isActive('/')}>Home</Link></li>
          <li><Link to="/about" className={isActive('/about')}>About</Link></li>
          <li><Link to="/contact" className={isActive('/contact')}>Contact</Link></li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
